import {
  FunctionComponent,
  useState,
  useEffect,
  useCallback,
  Fragment,
} from 'react'
import { useParams } from 'react-router'

import LoadingPage from '@/components/LoadingPage'
import { LightHeader } from '../../components/LightHeader'
import { ForgotPasswordForm } from '../../components/ForgotPasswordForm'
import { TimeZoneGMT } from '@conexasaude/hero-web'

import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import { getThemeByUniqueCode } from '@/theme'
import { setCache } from '@/utils/cache'
import { useStyles } from './useStyles'

interface ForgotPasswordParams {
  clinic?: string
}

const ForgotPassword: FunctionComponent = () => {
  const [isLoading, setIsLoading] = useState(true)
  const { clinic } = useParams<ForgotPasswordParams>()
  const { theme, setThemeColors } = useThemeGeneratorContext()
  const { container } = useStyles()

  const getAndSetThemeColors = useCallback(async () => {
    try {
      const colors = await getThemeByUniqueCode(clinic, theme)

      setThemeColors(colors)
    } catch {
      setThemeColors(null)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinic])

  useEffect(() => {
    setIsLoading(true)

    if (clinic) {
      getAndSetThemeColors()
      setCache('unique-code', clinic)
      setIsLoading(false)

      return
    }

    setThemeColors(null)
    setCache('unique-code', '')
    setIsLoading(false)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) return <LoadingPage withoutNav />

  return (
    <Fragment>
      <LightHeader
        uniqueCode={clinic}
        redirectTo={clinic ? `/login/${clinic}` : '/login'}
      />
      <div css={container}>
        <div className="forgot-password__noise"></div>
        <ForgotPasswordForm />
        <div className="tz-section">
          <TimeZoneGMT />
        </div>
      </div>
    </Fragment>
  )
}

export default ForgotPassword
